<template>
    <v-form ref="formEditCompany" v-model="validUpdateCompanyForm" lazy-validation>
        <v-row>
            <v-col cols="12">
                <v-card color="kbWhite">
                    <v-card-title>
                        <v-row>
                            <v-col cols="12">
                                <h4 class="font-weight-medium kbDarkBlueText--text">{{businessModule.s}}</h4>
                            </v-col>
                        </v-row>

                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="name" :label="$t('general.name')"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field v-model="phone" :rules="[rules.required]" :label="$t('general.phone')"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field v-model="email" :rules="[rules.required, rules.email]" :label="$t('general.email')"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field v-model="address" :label="$t('general.physicalAddress')"></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field v-model="url" :label="$t('general.webSiteUrl')"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn @click="submitUpdateCompany"
                               class="mb-2"
                               color="kbPurple"
                               dark
                               :disabled="!validUpdateCompanyForm"
                               :loading="updatingCompany">
                            {{$t('general.saveChanges')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'

export default {
  created () {
    if (this.selectedCompany) {
      this.name = this.selectedCompany.name
      this.phone = this.selectedCompany.phone
      this.email = this.selectedCompany.email
      this.address = this.selectedCompany.address
      this.url = this.selectedCompany.url
    }
  },
  computed: {
    ...mapState({
      selectedCompany: state => state.companies.selectedCompany,
      creditCards: state => state.payments.creditCards
    }),
    ...mapGetters(['businessModule'])
  },
  data: () => ({
    updatingCompany: false,
    validUpdateCompanyForm: false,
    name: '',
    phone: '',
    email: '',
    address: '',
    url: '',
    rules,
    jQuery: null,
    paymentez: null,
    picker: {
      country: 'Colombia',
      code: 'co',
      number: '57',
      phone: ''
    },
    cardNumber: '',
    cardExpires: '',
    cardCvc: '',
    updatingCardPriority: ''
  }),
  methods: {
    submitUpdateCompany () {
      if (!this.$refs.formEditCompany.validate()) return

      this.updatingCompany = true
      const data = {
        name: this.name,
        phone: this.phone,
        email: this.email,
        address: this.address,
        url: this.url
      }

      this.$store.dispatch('updateCompany', data).then(response => {
        if (response) {
          notifications.success('Negocio actualizado correctamente')
          this.updatingCompany = false
        }
      })
    }
  },
  watch: {
    selectedCompany (value) {
      this.name = value.name
      this.phone = value.phone
      this.email = value.email
      this.address = value.address
      this.url = value.url
    }
  }
}
</script>
